import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { JsonLd, breadcrumbSchema } from "@/components/StructuredData";

/**
 * Breadcrumbs — accepts items: [{name, path}]. Last item is the current page.
 */
export default function Breadcrumbs({ items = [] }) {
  const full = [{ name: "Home", path: "/" }, ...items];
  return (
    <>
      <JsonLd data={breadcrumbSchema(full)} />
      <nav
        aria-label="Breadcrumb"
        className="container-wide pt-6"
        data-testid="breadcrumbs"
      >
        <ol className="flex flex-wrap items-center gap-1.5 text-xs sm:text-sm text-muted-foreground">
          {full.map((it, idx) => {
            const isLast = idx === full.length - 1;
            return (
              <li key={it.path} className="flex items-center gap-1.5">
                {idx > 0 && <ChevronRight className="h-3.5 w-3.5" />}
                {isLast ? (
                  <span className="text-foreground" aria-current="page">
                    {idx === 0 ? <Home className="h-3.5 w-3.5 inline mr-1" /> : null}
                    {it.name}
                  </span>
                ) : (
                  <Link to={it.path} className="hover:text-foreground">
                    {idx === 0 ? <Home className="h-3.5 w-3.5 inline mr-1" /> : null}
                    {it.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}
